export default __webpack_public_path__ + "static/media/lynn-bruise.75d54969.jpg";